export const CLIENT_PASSPORT_TYPE = {
  PASSPORT: 'Passport',
  ID: 'ID',
};
